import React from 'react';
import { Loader } from '@entur/loader';
import { useIntl } from 'react-intl';
import styles from './styles.module.scss';

interface FetchingIndicatorProps {
  isFetching: boolean;
  children?: React.ReactNode;
  fill?: boolean;
}

export const FetchingIndicator = ({ isFetching = false, children, fill = false }: FetchingIndicatorProps) => {
  const intl = useIntl();

  return (
    <div className={`${styles.overlayContainer}${fill ? ` ${styles.fill}` : ''}`}>
      {isFetching && (
        <>
          <div className={styles.loadingOverlay} />
          <div className={styles.loadingSpinner}>
            <Loader>{intl.formatMessage({ id: 'generalValues.loading' })}</Loader>
          </div>
        </>
      )}
      {children}
    </div>
  );
};
